import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Contract } from "appworks/utils/contracts/contract";
import { Easing, Tween } from "appworks/utils/tween";
import { TGRFreespinIntroComponent } from "components/tgr-freespin-intro";
import { gameLayers } from "game-layers";

export class DMFFreespinIntroComponent extends TGRFreespinIntroComponent {

    public animateSymbolsSprites(): Contract<void> {
        return new Contract<void>((resolve: (value?: any) => void) => {
            [2, 3, 2, 2, 3].forEach((syms: number, reel: number) => {
                for (let i: number = 0; i < syms; i++) {
                    const startPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`start_${reel}_${i}`);
                    const pauseStartPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`pause_start_${reel}_${i}`);
                    const pauseEndPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`pause_end_${reel}_${i}`);
                    const endPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`end_${reel}_${i}`);

                    const assetName: string = reel === 4 ? "C_intro" : "QH_intro";
                    const symSprite: Sprite = this.makeSymbolSprite(assetName, startPos);

                    const endTween = new Tween(symSprite.landscape);
                    endTween.to({y: endPos.landscape.y}, 500);
                    endTween.easing(Easing.Quadratic.In);
                    endTween.onComplete(() => {
                        gameLayers.FreespinsIntro.remove(symSprite);
                        if (reel === 4 && i === 2) {
                            resolve();
                        }
                    });

                    const pauseTween = new Tween(symSprite.landscape);
                    pauseTween.to({y: pauseEndPos.landscape.y}, 1500);
                    pauseTween.chain(endTween);

                    const startTween = new Tween(symSprite.landscape);
                    startTween.delay(60 * reel);
                    startTween.to({y: pauseStartPos.landscape.y}, 500);
                    startTween.chain(pauseTween);
                    startTween.start();
                }
            });
        });
    }
}
